import * as PIXI from 'pixi.js';

import { TypedSerializableMixin } from '../../serializableMixin';
import { TypedUpdateFlowMixin } from '../../updateFlowMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    NumberAttribute,
    getAttributesToSerialize,
} from '../../attributes';
import type { LoadSettings } from '../../serializableMixin';
import type { RawAssetData } from '../../../video-data/types';
import { Config } from '../../../video-data/config';
import { getCircleOffsetByRadiusAndStrokeWidth } from '../../CircleUtils';

/**
 * Draws a colored bounding box around the entire text(Metrics)
 *
 */
export class CircleGraphic extends TypedUpdateFlowMixin(TypedSerializableMixin(PIXI.Graphics)) {
    override _classType = 'CircleGraphic';
    override _name = Config.CIRCLE_GRAPHIC;

    @NumberAttribute({ min: 0 })
    accessor radius = 0;
    @NumberAttribute({ animatable: false })
    accessor positionX = 0;
    @NumberAttribute({ animatable: false })
    accessor positionY = 0;
    @ColorAttribute()
    accessor strokeColor = 16777215;
    @AlphaAttribute()
    accessor strokeAlpha = 1;
    @NumberAttribute({ min: 0, animatable: false })
    accessor strokeWidth = 0;
    @ColorAttribute()
    accessor fillColor = 16777215;
    @AlphaAttribute()
    accessor fillAlpha = 1;

    #nonAnimatedRadius: number = 0;

    override load(dataObj: RawAssetData, settings?: LoadSettings) {
        super.load(dataObj, settings);
        this.#nonAnimatedRadius = this.radius;
    }

    override _update() {
        this.clear();
        this.lineStyle(this.strokeWidth, this.strokeColor, this.strokeAlpha);
        this.beginFill(this.fillColor, this.fillAlpha);

        const offset = getCircleOffsetByRadiusAndStrokeWidth(
            this.#nonAnimatedRadius,
            this.strokeWidth,
        );

        this.drawCircle(this.positionX + offset, this.positionY + offset, this.radius);
        this.endFill();
    }

    override get propertiesToSerialize(): string[] {
        return getAttributesToSerialize(this);
    }
}
